// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonBase__root___2GNnu"};